import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { CheckBoxIconProps } from './types/CheckBoxIconProps';

export const CheckBoxOutlineBlankIcon = ({
  flush = false,
  ...props
}: CheckBoxIconProps): ReactNode => (
  <Icon
    {...props}
    testId={locator.components.icon.checkBoxOutlineBlank}
    viewBox={flush ? '3 3 18 18' : '0 0 24 24'}
  >
    <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  </Icon>
);
